export default __webpack_public_path__ + "static/media/news-20.5af74580.jpeg";